import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVibeCoding2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVibeCoding2"><Path d="M10.0303 5.03027L3.06055 12L10.0303 18.9697L8.96973 20.0303L0.939453 12L8.96973 3.96973L10.0303 5.03027Z" fill="currentColor"/><Path d="M22.5303 12.5303L15.0303 20.0303L13.9697 18.9697L21.4697 11.4697L22.5303 12.5303Z" fill="currentColor"/><Path d="M18.4004 5.59961L21 6.59961V7.40039L18.4004 8.40039L17.4004 11H16.5996L15.5996 8.40039L13 7.40039V6.59961L15.5996 5.59961L16.5996 3H17.4004L18.4004 5.59961Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVibeCoding2;
